import React, { useEffect, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { Typography } from '@mui/material';
import CusInput from '../../../components/material-ui/CusInput';
import { API_USERS } from '../../../api/users';
import { useDispatch } from 'react-redux';
import { updateUserResult } from '../../../store/apps/usersSlice';

export default function ChangeLoginModal({ open, closeModal, user, setSelectUserFull }) {
  const dispatch = useDispatch();
  const defaultLogin = user.login;
  const [login, setLogin] = useState(defaultLogin);

  const onSaveClick = () => {
    API_USERS.info
      .changeLogin({ userId: user.userId, newLogin: login })
      .then((e) => {
        setSelectUserFull((prev) => ({ ...prev, login: login }));
        dispatch(updateUserResult({ id: user.userId, dataIndx: 1, value: login }));

        closeModal();
      })
      .catch(console.error);
  };

  useEffect(() => {
    setLogin(defaultLogin);
  }, [defaultLogin]);

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      title={'Change Login'}
      maxWidth="xs"
      onSaveClick={onSaveClick}
      saveText="Confirm">
      <CusInput
        label={'Login'}
        value={login}
        autoFocus={open}
        onChange={(e) => setLogin(e.target.value)}
      />
    </InfoDialog>
  );
}
